module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'fields',
		'select'
	],

	model: {
		config: {
			hours: {
				// min: 0,
				// max: 23,
				// list: [8, 16, 23]
			},
			minutes: {
				// min: 0,
				// max: 59,
				// list: [0,30]
			},
			// renderConfig: {
			// 	defaultOptionEntry: {
			// 		name: 'wählen',
			// 		value: null
			// 	}
			// }
		}
	},

	methods: {
		prepare: function(){
			if(!this.model.initialized){
				this.model.initialized = true;

				var dataAttributeKey;
				if(this.model.atom && !!this.model.atom.dataType){
					dataAttributeKey = this.model.atom.dataType + '-data';
				} else {
					dataAttributeKey = 'data';
				}

				var fieldConfig = this.model.config;
				var hourConfig = fieldConfig.hours || {};
				var minuteConfig = fieldConfig.minutes || {};
				var hours = []
				var minutes = []
				var options = []
				var h, m, value;

				if(hourConfig.list){
					hours = hourConfig.list
				} else {
					for(h = (hourConfig.min || 0); h <= (hourConfig.max || 23); h++){
						hours.push(h)
					}
				}
				if(minuteConfig.list){
					minutes = minuteConfig.list
				} else {
					for(m = (minuteConfig.min || 0); m <= (minuteConfig.max || 59); m++){
						minutes.push(m)
					}
				}
				for(h of hours){
					for(m of minutes) {
						value = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
						options.push({
							value,
							name: value
						})
					}
				}

				this.model[dataAttributeKey] = options
			}
		},
	},
}